import { FunctionComponent } from "react";
import styled from "styled-components";

import { CXL, H2, H3 } from "@/components/Typography";
import { colours } from "@/utils";
import { Device } from "@/utils/device";
import FramedImage from "../spaces/FramedImage";
import MarketingLink from "../MarketingLink";

const content = [
  {
    imagePath: "/images/marketing/two-members-hugging.png",
    alt: "two AllBright members hugging",
    subtitle: "Strengthening connections",
    copy: "with empowering social events, sparking diverse perspectives and unexpected friendships.",
  },
  {
    imagePath: "/images/marketing/working-on-laptop.png",
    alt: "a smiling woman seated on a sofa working on a laptop",
    subtitle: "Honing essential skills",
    copy: "with world-class learning resources that evolve with careers.",
  },
  {
    imagePath: "/images/marketing/four-allbright-members-seated.png",
    alt: "four smiling AllBright members seated on a sofa and smiling at the camera",
    subtitle: "Uniting organisations",
    copy: "with a global alliance of businesses and brands, co-creating the future of work.",
  },
];

const WeDoThisContent: FunctionComponent = () => {
  return (
    <S.Section>
      <S.Title>We do this in three ways:</S.Title>
      <S.CenterContent>
        <S.ContentContainer>
          {content.map((item) => {
            return (
              <S.Content key={item.subtitle}>
                <FramedImage imgSrc={item.imagePath} alt={item.alt} />
                <S.Subtitle>{item.subtitle}</S.Subtitle>
                <S.Copy>{item.copy}</S.Copy>
              </S.Content>
            );
          })}
        </S.ContentContainer>
        <S.LinkPositioning>
          <MarketingLink linkText="Join AllBright" href="/memberships" />
        </S.LinkPositioning>
      </S.CenterContent>
    </S.Section>
  );
};

const S = () => {};

S.Section = styled.section`
  margin: 2rem 2rem 4rem 2rem;
  display: flex;
  flex-direction: column;
`;

S.Title = styled(H2)`
  padding: 2rem 6rem 4rem 6rem;
  font-family:
    Roxborough CF,
    sans-serif;
  font-size: 4rem;
  font-weight: 100;
  line-height: 4rem;
  letter-spacing: -1px;
  text-align: center;
  color: ${colours.charcoal};

  @media (min-width: ${Device.desktop}) {
    font-size: 6rem;
    padding: 6rem 6rem 8rem 6rem;
  }
`;

S.ContentContainer = styled.section`
  @media (min-width: ${Device.mobile}) {
    padding: 0 10rem;
  }

  @media (min-width: ${Device.tablet}) {
    padding: 0;
    display: flex;
    justify-content: center;
    gap: 2rem;
  }
`;

S.Content = styled.div`
  @media (min-width: ${Device.tablet}) {
    flex-shrink: 0;
    width: 22%;
  }

  @media (min-width: ${Device.desktop}) {
    width: 28%;
  }
`;

S.Subtitle = styled(H3)`
  padding-top: 3rem;
  font-family:
    Roxborough CF,
    sans-serif;
  font-size: 2.75rem;
  font-weight: 100;
  line-height: 2.125rem;
  color: ${colours.charcoal};
`;

S.Copy = styled(CXL)`
  padding: 2rem 0 3rem 0;
  font-size: 1.5rem;
  line-height: 2.125rem;
  color: ${colours.charcoal};
`;

S.CenterContent = styled.div`
  align-self: center;
`;

S.LinkPositioning = styled.div`
  @media (min-width: ${Device.mobile}) {
    padding-left: 10rem;
  }

  @media (min-width: ${Device.tablet}) {
    padding-left: 15%;
  }

  @media (min-width: ${Device.desktop}) {
    padding-top: 60px;
    padding-bottom: 60px;
    padding-left: 7%;
  }
`;

export default WeDoThisContent;
